import './Grid.scss';

export function Row({ children }) {
  return (
    <div className="row">{children}</div>
  );
}

export function Col({ size = 6, children }) {
  return (
    <div className={`col col-${size}`}>{children}</div>
  );
}
